import React from "react";
import { Box, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { Navigation } from "swiper";

export default function GigCategorySlider({ title, data }) {
  return (
    <Stack alignItems="center" pb={16}>
      <Heading fontWeight={"semibold"} fontSize={{ base: "24px", md: "34px" }}>
        {title}
      </Heading>
      <Box width="100%" py={10}>
        <Swiper
          // slidesPerView={"5"}

          spaceBetween={30}
          breakpoints={{
            "0": {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            "480": {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            "770": {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            900: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1100: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
          }}
          pagination={{
            clickable: true,
          }}
          loop={true}
          navigation={true}
          modules={[Navigation]}
          className="mySwiper marketplace-slider"
        >
          {[...data, ...data].map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <Link to="/marketplace/logo-design">
                  <Box cursor="pointer" type="button">
                    <Image src={item.imageUrl} w="full" />
                    <Text
                      fontSize={{ base: "18px", md: "22px" }}
                      py={2}
                      fontWeight="semibold"
                    >
                      {item.label}
                    </Text>
                  </Box>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Box>
    </Stack>
  );
}
